<template>
  <div>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>valla</title>
      <path fill="#679940"
        d="M28,4.5H4a1,1,0,0,0-1,1v15a1,1,0,0,0,1,1H5v6H7v-6H25v6h2v-6h1a1,1,0,0,0,1-1V5.5A1,1,0,0,0,28,4.5Zm-1,15H5V6.5H27Z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Vallas"
};
</script>


// WEBPACK FOOTER //
// src/icons/VallasIcon.vue